import { InstrumentType } from '@fretgenius/core';
import { useFretboardConfigStore } from '@/features/fretboard-base';
import React from 'react';

export const InstrumentSelector: React.FC = () => {
  const instrumentType = useFretboardConfigStore((state) => state.instrumentType);
  const setInstrumentType = useFretboardConfigStore((state) => state.setInstrumentType);

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    // We know the values in the select match InstrumentType enum values
    // Create a type guard to ensure type safety
    const isValidInstrumentType = (value: string): value is InstrumentType => {
      return Object.values(InstrumentType).some((enumValue) => enumValue === value);
    };

    if (isValidInstrumentType(e.target.value)) {
      setInstrumentType(e.target.value);
    }
  };

  return (
    <div className="form-control w-full mb-2">
      <label className="label">
        <span className="label-text">Instrument</span>
      </label>
      <select
        className="select select-bordered w-full"
        value={instrumentType}
        onChange={handleChange}
      >
        {Object.values(InstrumentType).map((inst) => (
          <option key={inst} value={inst}>
            {inst}
          </option>
        ))}
      </select>
    </div>
  );
};
